<div>
    <!-- #createForm -->
    <ng-container *ngIf="options">
        <aumico-form [options]="options" [delegate]="formDelegate" [data]="newState"> </aumico-form>
    </ng-container>
</div>
